.dy{z-index:50;}